import { motion } from 'framer-motion'
import BadgeRow from '../components/BadgeRow'
import Form from '../components/Form'
import SEO from '../utils/seo'

const Subscribe = () => {
  return (
    <>
      <SEO
        title="Subscribe"
        description="Watch Prompted Thoughts on YouTube or listen on your favorite podcast platform. Never miss an episode!"
      />

      <div className="section">
        <div className="container-custom max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-off-white mb-4">
              Watch & Listen Everywhere <span className="text-2xl text-purple font-mono">(Coming Soon)</span>
            </h1>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Full video episodes on YouTube, plus audio on all major podcast platforms
            </p>
          </motion.div>

          {/* Platform badges */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-16"
          >
            <BadgeRow />
          </motion.div>

          {/* Why Subscribe section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mb-16"
          >
            <h2 className="text-3xl font-bold text-off-white mb-8 text-center">
              Why Subscribe?
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  icon: '📺',
                  title: 'Watch on YouTube',
                  description: 'Full video episodes with visual demos, code walkthroughs, and guest conversations',
                },
                {
                  icon: '🎧',
                  title: 'Listen on the Go',
                  description: 'Audio versions available on Apple Podcasts, Spotify, and all major platforms',
                },
                {
                  icon: '🔔',
                  title: 'Never Miss an Episode',
                  description: 'Subscribe once and get automatic notifications for every new release',
                },
              ].map((item, index) => (
                <div
                  key={item.title}
                  className="bg-slate/40 backdrop-blur-sm rounded-lg p-6 text-center border border-slate hover:border-cyan/50 transition-all"
                >
                  <div className="text-5xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-bold text-off-white mb-3">{item.title}</h3>
                  <p className="text-gray-400">{item.description}</p>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Newsletter signup */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="max-w-xl mx-auto"
          >
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-off-white mb-4">Join Our Newsletter</h2>
              <p className="text-gray-400">
                Get episode summaries, show notes, and exclusive content delivered to your inbox
              </p>
            </div>
            <Form type="newsletter" />
          </motion.div>

          {/* RSS Feed info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="mt-16 pt-8 border-t border-slate text-center"
          >
            <h3 className="text-lg font-semibold text-off-white mb-3">
              Prefer to use your own RSS reader?
            </h3>
            <p className="text-gray-400 mb-4">Copy this URL into your favorite podcast app:</p>
            <div className="bg-slate/60 rounded-lg p-4 font-mono text-sm text-cyan break-all max-w-2xl mx-auto">
              https://promptedthoughts.dev/feed.xml
            </div>
          </motion.div>
        </div>
      </div>
    </>
  )
}

export default Subscribe
